import { render, staticRenderFns } from "./ScheduleCreatePage.vue?vue&type=template&id=164bf795&scoped=true&"
import script from "./ScheduleCreatePage.vue?vue&type=script&lang=ts&"
export * from "./ScheduleCreatePage.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleCreatePage.vue?vue&type=style&index=0&id=164bf795&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164bf795",
  null
  
)

export default component.exports